import { render, staticRenderFns } from "./call-recording-audio.vue?vue&type=template&id=bbb45b3e&scoped=true&"
import script from "./call-recording-audio.vue?vue&type=script&lang=js&"
export * from "./call-recording-audio.vue?vue&type=script&lang=js&"
import style0 from "./call-recording-audio.vue?vue&type=style&index=0&id=bbb45b3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb45b3e",
  null
  
)

export default component.exports